module.exports = __webpack_public_path__ + "img/bg.71564d48.jpg";